import { useGetJobSiteFormOptionsQuery } from '@/common/infrastructure/gql/generated/schema';
import { getDefaultId } from '@/raptorjob/application/utils/erpSettings';
import { useMemo } from 'react';

export const useGetJobSiteFormOptions = (skip: boolean) => {
  const { data, loading, error } = useGetJobSiteFormOptionsQuery({ skip });

  const jobSiteTypes = useMemo(() => data?.jobsiteTypes?.items ?? [], [data]);
  const defaultJobSiteTypeId = getDefaultId(jobSiteTypes);

  return {
    loading,
    error,
    availableJobSiteTypes: jobSiteTypes,
    defaultJobSiteTypeId
  };
};
